import { API_URL, getCachedSessionId } from 'src/services/common';

import { fetchZohoDealsResponseData } from './interfaces/fetchZohoDealsResponseData.interface';
import { api } from '../../../../util/axios-instance';

export const fetchZohoDeals = async (params: {
  orderBy: string;
  orderDirection: string;
  page: string;
  pageSize: string;
  projectId: string;
  search: string;
  status: string;
}): Promise<fetchZohoDealsResponseData | undefined> => {
  const { projectId, page, pageSize, orderBy, orderDirection, status, search } = params;

  const notPaid = status === 'Not Paid' ? 'true' : 'false';

  const response = await api.get<fetchZohoDealsResponseData>(
    `${API_URL}/v1/project/${projectId}/provider/zohodeals?page=${page}&limit=${pageSize}&orderBy=${orderBy}&orderDirection=${orderDirection}&notPaid=${notPaid}&search=${search}`,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};

export const fetchZohoDealsCSV = async (params: { projectId: string }) => {
  const { projectId } = params;
  const response = await api.get(`${API_URL}/v1/project/${projectId}/provider/zohodeals/csv`, {
    headers: { 'x-session-id': getCachedSessionId() }
  });

  return response.data;
};
